module.exports = __webpack_public_path__ + "static/img/logo1.069593a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/logo1.png
// module id = yKHM
// module chunks = 1